export default __webpack_public_path__ + "static/media/gis-loading.81453d27.gif";